import {useCallback, useState, SyntheticEvent} from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, {AlertProps} from '@mui/material/Alert';
import ReactDOM from "react-dom";
import styled from "styled-components";

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Root = styled.div`
  width: 100%;
  & > * + * {
    margin-top: 16px;
  }
`;

export enum TOAST_TYPES {
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "error",
    INFO = "info"
}

interface ToastProps {
    type: TOAST_TYPES;
    message: string;
}

export function Toast({type = TOAST_TYPES.SUCCESS, message = 'Success!'}: ToastProps) {
    const [open, setOpen] = useState(true);

    const handleClose = useCallback((event?: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    }, []);

    const domNode = document.getElementById('root');
    if (!domNode) {
        return null;
    }

    return ReactDOM.createPortal(
        <Root>
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={type}>
                    {message}
                </Alert>
            </Snackbar>
        </Root>,
        domNode
    );
}
